module.exports = __webpack_public_path__ + "static/media/search.a09aff22.svg";